module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA80lEQVRYR+1W2xVBMRCcqYAO6IASqIASdEAHdEALOrg6UAIdUMk4e04+4rivuJL4yH4nO7OzTyKzMTM+CoEPBSTtAKwipeZC8uT7riOwBjCPROBGsmolEAm40W0pwqLAIAUkTQFMAgr3SfLxVRdIWgB4+A7czDgGEDiT3AQRcFEaiM2HJclrAGDn08YUSBoD2AI4eF7SEJBkMlnURsK3pARsZo+yEDBQlwJbTPvkKfCjdkVoatiGTJOCutLN1oZtfeTUsWHU197miH0aNAn7ora9KwSKAk1H6ewXBVbj4955lLoVa5svhlWdZ3kM1NKGf63ACzUdUCHpu3IjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sq.png
// module id = rWRm
// module chunks = 5